import React, { Component } from "react";
import { Row, Col, Button, Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import PropTypes from "prop-types";
import { ModalStyles } from "components/Common/styles.js";
import { languageService } from "../../Language/language.service";
import { CommonModalStyle, ButtonStyle } from "style/basic/commonControls";
import { themeService } from "theme/service/activeTheme.service";
import { basicColors, retroColors, electricColors } from "style/basic/basicColors";
const MyButton = (props) => (
  <button className="setPasswordButton" {...props}>
    {props.children}
  </button>
);
/**
 * Renders a user-friendly Confirmation Dialog bar in single line with the type and message separated by a colon ':'
 * @param {bool} props.modal -The boolean to show or hide the modal.
 * @param {func} props.toggle - A function for the toggling of the modal
 * @param {string} props.className -  CSS class to apply styling to the modal.
 * @param {func} props.maxHeight -  Whether to set the tooltip's max-height to 100%.
 * @param {string} props.headerText - A header text to show in modal header.
 * @param {string} props.confirmationMessage - A confirmation message for modal whether to confirm or not.
 * @param {string} props.handleResponse - A function confirm or cancel the modal.
 * @returns {JSX.Element} rendered component
 */
class ConfirmationDialog extends Component {
  static propTypes = {
    modal: PropTypes.bool.isRequired,
    toggle: PropTypes.func.isRequired,
    className: PropTypes.string,
    headerText: PropTypes.string.isRequired,
    confirmationMessage: PropTypes.string.isRequired,
    handleResponse: PropTypes.func.isRequired,
    hideConfirm: PropTypes.bool,
  };
  render() {
    return (
      <Modal
        isOpen={this.props.modal}
        toggle={this.props.toggle}
        contentClassName={themeService({ default: this.props.className, retro: "retroModal", electric: "electricModal" })}
      >
        <ModalHeader style={(ModalStyles.modalTitleStyle, themeService(CommonModalStyle.header))}> {this.props.headerText}</ModalHeader>
        <ModalBody style={(ModalStyles.footerButtonsContainer, themeService(CommonModalStyle.body))}>
          <div
            style={themeService({
              default: { ...ModalStyles.modalBodyColor },
              retro: { color: "var(--second)" },
              electric: { color: electricColors.second },
            })}
          >
            {this.props.confirmationMessage}
          </div>
        </ModalBody>
        <ModalFooter style={(ModalStyles.footerButtonsContainer, themeService(CommonModalStyle.footer))}>
          {!this.props.hideConfirm && (
            <MyButton
              style={themeService(ButtonStyle.commonButton)}
              onClick={(e) => {
                this.props.handleResponse(true);
              }}
            >
              {languageService("Confirm")}
            </MyButton>
          )}
          <MyButton
            style={themeService(ButtonStyle.commonButton)}
            onClick={(e) => {
              this.props.handleResponse(false);
            }}
          >
            {this.props.hideConfirm ? languageService("Ok") : languageService("Cancel")}
          </MyButton>
        </ModalFooter>
      </Modal>
    );
  }
}

export default ConfirmationDialog;



// WEBPACK FOOTER //
// ./src/components/Common/ConfirmationDialog.jsx